import {createSlice, createAsyncThunk} from "@reduxjs/toolkit"
import {post} from "helpers/api"

export const initialState = {
	reports: {
		total: 0,
		data: []
	},
	generateReportsApiState: {
		isSuccess: false,
		isFetching: false,
		message: "",
		isError: false
	}
}

export const generateEmployerCodeReports = createAsyncThunk(
	"reports/generateEmployerCodeReports",
	async ({data, token}, thunkAPI) => {
		try {
			let response = await post("v2/codes/generateReport", data, "application/json", {
				Authorization: `Bearer ${token}`
			})
			return response
		} catch (e) {
			return thunkAPI.rejectWithValue("Something went wrong while fetching. Please contact our support")
		}
	}
)


const reportsSlice = createSlice({
	name: "reports",
	initialState: initialState,
	reducers: {
		clearApiState: state => {
			state.generateReportsApiState.isSuccess = false
			state.generateReportsApiState.isError = false
			state.generateReportsApiState.isFetching = false
			state.generateReportsApiState.message = ""

			return state
		}
	},
	extraReducers: {
		[generateEmployerCodeReports.fulfilled]: (state, {payload}) => {
			state.total = payload.totalCount
			state.reports = payload.data
			state.generateReportsApiState.isFetching = false
			state.generateReportsApiState.isSuccess = true
		},
		[generateEmployerCodeReports.rejected]: state => {
			state.generateReportsApiState.isError = true
			state.generateReportsApiState.isFetching = false
			state.generateReportsApiState.message = payload?.error
		},
		[generateEmployerCodeReports.pending]: state => {
			state.generateReportsApiState.isFetching = true
		}
	}
})

export const {clearApiState} = reportsSlice.actions

export const reportsSelector = state => state.reports

export default reportsSlice
